<section class="category-section">
  <div class="sidebar">
    <h3>Categories</h3>

    <ul class="categories-link" #categoryList>
      <li>
        <a
          [routerLink]="['/help-center/all']"
          routerLinkActive="active"
          (click)="
            redirectToHelpCenter(); showAllCategories(); toggleClosedAccordion()
          "
        >
          All
        </a>
      </li>

      <li *ngFor="let category of allContentCategories$">
        <a
          [routerLink]="['/help-center/' + category.code]"
          class="categoryLinks"
          (click)="toggleClosedAccordion()"
          [class.active]="setActiveLeftCategory(category)"
        >
          {{ category?.name }}
        </a>
      </li>
    </ul>
    <app-custom-most-popular-component></app-custom-most-popular-component>
  </div>
  <div class="category-content position-relative">
    <div>
       @if (!allContentCategories$ ) {
          <mat-spinner class="spinner absolute top200" mode="indeterminate" diameter="100"></mat-spinner>
        }
      <div *ngIf="selectedCategory">
        
        <a
          href="javascript:void(0);"
          (click)="toggleAllAccordion()"
          class="expandAllAccordion"
          >+/- All</a
        >

        <h2 class="category-name">{{ selectedCategory.name }}</h2>

        <div class="accordions">
          <div
            class="accordion"
            *ngFor="let item of selectedCategory.contentItems; let i = index"
            [ngClass]="{
              selected: item.selected
            }"
          >
            <div class="accordion-header" (click)="toggleAccordion(item)">
              <h3 class="accordion-title">{{ item.title }}</h3>
              <span class="accordion-icon">{{
                item.selected ? "-" : "+"
              }}</span>
            </div>
            <div class="accordion-content" *ngIf="item.selected">
              <div class="content-data" [innerHTML]="item.content"></div>
              <div *ngFor="let item of item.contentDocuments; let i = index">
                <div>
                  <a
                    *ngIf="item.type == 'PAGE_LINK'"
                    href="{{ item.url }}"
                    target="_blank"
                    class="linkText"
                    >{{ item.linkText }}</a
                  >
                </div>
              </div>

              <h1 *ngIf="showHeading(item?.contentDocuments)">
                <p class="resources-text">Resources</p>
              </h1>

              <div *ngFor="let item of item.contentDocuments; let i = index">
                <p
                  class="resources-text"
                  *ngIf="item.type == 'YOUTUBE_VIDEO' || item.type == 'VIDEO'"
                >
                  {{ item.linkText }}
                </p>

                <div>
                  <div
                    class="document-info d-flex flex-wrap justify-content-between"
                    *ngIf="item.type == 'PDF'"
                  >
                    <a
                      *ngIf="item.type == 'PDF'"
                      href="{{ item.url }}"
                      target="_blank"
                      class="linkText"
                      >{{ item.linkText }}</a
                    >
                    <a href="{{ item.url }}" class="viewAllText" target="_blank"
                      >View
                      <img
                        src="../../../assets/icons/viewIconNew.svg"
                        width="15"
                        height="20"
                    /></a>
                  </div>
                </div>

                <div class="youtube_video" *ngIf="item.type == 'YOUTUBE_VIDEO'">
                  <iframe
                    width="345"
                    class="iframe-youtube"
                    allowfullscreen=""
                    height="194"
                    [attr.src]="item?.url | safe : 'resourceUrl'"
                  >
                  </iframe>
                </div>
                <div class="youtube_video" *ngIf="item.type == 'VIDEO'">
                  <iframe
                    width="345"
                    class="iframe-youtube"
                    allowfullscreen=""
                    height="194"
                    [attr.src]="item?.url | safe : 'resourceUrl'"
                  >
                  </iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!selectedCategory">
      <a
        href="javascript:void(0);"
        (click)="toggleAllAccordion()"
        class="expandAllAccordion"
        >+/- All</a
      >

      <div *ngIf="filteredContents$; else contentItem">
        <div *ngFor="let category of filteredContents$">
          <h2 class="category-name">{{ category?.name }}</h2>

          <div class="accordions">
            <div
              class="accordion"
              *ngFor="let item of category?.contentItems; let i = index"
              [ngClass]="{ selected: item.selected }"
            >
              <div class="accordion-header" (click)="toggleAccordion(item)">
                <h3 class="accordion-title">{{ item.title }}</h3>

                <span class="accordion-icon">{{
                  item.selected ? "-" : "+"
                }}</span>
              </div>

              <div class="accordion-content" *ngIf="item.selected">
                <div class="content-data" [innerHTML]="item.content"></div>
                <div *ngFor="let item of item.contentDocuments; let i = index">
                  <div>
                    <a
                      *ngIf="item.type == 'PAGE_LINK'"
                      href="{{ item.url }}"
                      target="_blank"
                      class="linkText"
                      >{{ item.linkText }}</a
                    >
                  </div>
                </div>

                <h1 *ngIf="showHeading(item?.contentDocuments)">
                  <p class="resources-text">Resources</p>
                </h1>

                <div *ngFor="let item of item.contentDocuments; let i = index">
                  <p
                    class="resources-text"
                    *ngIf="item.type == 'YOUTUBE_VIDEO' || item.type == 'VIDEO'"
                  >
                    {{ item.linkText }}
                  </p>

                  <div>
                    <div
                      class="document-info d-flex flex-wrap justify-content-between"
                      *ngIf="item.type == 'PDF'"
                    >
                      <a
                        *ngIf="item.type == 'PDF'"
                        href="{{ item.url }}"
                        target="_blank"
                        class="linkText"
                        >{{ item.linkText }}</a
                      >
                      <a
                        href="{{ item.url }}"
                        class="viewAllText"
                        target="_blank"
                        >View
                        <img
                          src="../../../assets/icons/viewIconNew.svg"
                          width="15"
                          height="20"
                      /></a>
                    </div>
                  </div>

                  <div
                    class="youtube_video"
                    *ngIf="item.type == 'YOUTUBE_VIDEO'"
                  >
                    <iframe
                      width="345"
                      class="iframe-youtube"
                      allowfullscreen=""
                      height="194"
                      [attr.src]="item?.url | safe : 'resourceUrl'"
                    >
                    </iframe>
                  </div>

                  <div class="youtube_video" *ngIf="item.type == 'VIDEO'">
                    <iframe
                      width="345"
                      class="iframe-youtube"
                      allowfullscreen=""
                      height="194"
                      [attr.src]="item?.url | safe : 'resourceUrl'"
                    >
                    </iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #contentItem>
        <div *ngFor="let category of contentItemList$">
          <h2 class="category-name">{{ category?.name }}</h2>

          <div class="accordions">
            <div
              class="accordion"
              *ngFor="let item of category?.contentItems; let i = index"
              [ngClass]="{ selected: item.selected }"
            >
              <div *ngIf="category.selected === true; else fullList">
                <div class="accordion-header" (click)="toggleAccordion(item)">
                  <h3 class="accordion-title">{{ item.title }}</h3>

                  <span class="accordion-icon">{{
                    item.selected ? "-" : "+"
                  }}</span>
                </div>

                <div class="accordion-content" *ngIf="item.selected">
                  <div class="content-data" [innerHTML]="item.content"></div>
                  <div
                    *ngFor="let item of item.contentDocuments; let i = index"
                  >
                    <div>
                      <a
                        *ngIf="item.type == 'PAGE_LINK'"
                        href="{{ item.url }}"
                        target="_blank"
                        class="linkText"
                        >{{ item.linkText }}</a
                      >
                    </div>
                  </div>

                  <h1 *ngIf="showHeading(item?.contentDocuments)">
                    <p class="resources-text">Resources</p>
                  </h1>
                  <div
                    *ngFor="let item of item.contentDocuments; let i = index"
                  >
                    <p
                      class="resources-text"
                      *ngIf="
                        item.type == 'YOUTUBE_VIDEO' || item.type == 'VIDEO'
                      "
                    >
                      {{ item.linkText }}
                    </p>

                    <div>
                      <div
                        class="document-info d-flex flex-wrap justify-content-between"
                        *ngIf="item.type == 'PDF'"
                      >
                        <a
                          *ngIf="item.type == 'PDF'"
                          href="{{ item.url }}"
                          target="_blank"
                          class="linkText"
                          >{{ item.linkText }}</a
                        >
                        <a
                          href="{{ item.url }}"
                          class="viewAllText"
                          target="_blank"
                          >View
                          <img
                            src="../../../assets/icons/viewIconNew.svg"
                            width="15"
                            height="20"
                        /></a>
                      </div>
                    </div>

                    <div
                      class="youtube_video"
                      *ngIf="item.type == 'YOUTUBE_VIDEO'"
                    >
                      <iframe
                        width="345"
                        class="iframe-youtube"
                        allowfullscreen=""
                        height="194"
                        [attr.src]="item?.url | safe : 'resourceUrl'"
                      >
                      </iframe>
                    </div>
                    <div class="youtube_video" *ngIf="item.type == 'VIDEO'">
                      <iframe
                        width="345"
                        class="iframe-youtube"
                        allowfullscreen=""
                        height="194"
                        [attr.src]="item?.url | safe : 'resourceUrl'"
                      >
                      </iframe>
                    </div>
                  </div>
                </div>
              </div>

              <ng-template #fullList>
                <div
                  class="accordion-header"
                  (click)="toggleAccordion(item)"
                  *ngIf="i < 3"
                >
                  <h3 class="accordion-title">{{ item?.title }}</h3>

                  <span class="accordion-icon">{{
                    item.selected ? "-" : "+"
                  }}</span>
                </div>
                <div *ngIf="i < 3">
                  <div class="accordion-content" *ngIf="item?.selected">
                    <div class="content-data" [innerHTML]="item?.content"></div>
                    <div
                      *ngFor="let item of item?.contentDocuments; let i = index"
                    >
                      <div>
                        <a
                          *ngIf="item.type == 'PAGE_LINK'"
                          href="{{ item.url }}"
                          target="_blank"
                          class="linkText"
                          >{{ item.linkText }}</a
                        >
                      </div>
                    </div>

                    <h1 *ngIf="showHeading(item?.contentDocuments)">
                      <p class="resources-text">Resources</p>
                    </h1>

                    <div
                      *ngFor="let item of item?.contentDocuments; let i = index"
                    >
                      <h1
                        *ngIf="
                          item?.type == 'PDF' ||
                          item?.type == 'YOUTUBE_VIDEO' ||
                          item?.type == 'VIDEO'
                        "
                      >
                        <p
                          class="resources-text"
                          *ngIf="
                            item?.type == 'YOUTUBE_VIDEO' ||
                            item?.type == 'VIDEO'
                          "
                        >
                          {{ item.linkText }}
                        </p>
                      </h1>
                      <div>
                        <div
                          class="document-info d-flex flex-wrap justify-content-between"
                          *ngIf="item?.type == 'PDF'"
                        >
                          <a
                            *ngIf="item?.type == 'PDF'"
                            href="{{ item?.url }}"
                            target="_blank"
                            class="linkText"
                            >{{ item.linkText }}</a
                          >
                          <a
                            href="{{ item.url }}"
                            class="viewAllText"
                            target="_blank"
                            >View
                            <img
                              src="../../../assets/icons/viewIconNew.svg"
                              width="15"
                              height="20"
                          /></a>
                        </div>
                      </div>

                      <div
                        class="youtube_video"
                        *ngIf="item.type == 'YOUTUBE_VIDEO'"
                      >
                        <iframe
                          width="345"
                          class="iframe-youtube"
                          allowfullscreen=""
                          height="194"
                          [attr.src]="item?.url | safe : 'resourceUrl'"
                        >
                        </iframe>
                      </div>
                      <div class="youtube_video" *ngIf="item.type == 'VIDEO'">
                        <iframe
                          width="345"
                          class="iframe-youtube"
                          allowfullscreen=""
                          height="194"
                          [attr.src]="item?.url | safe : 'resourceUrl'"
                        >
                        </iframe>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="view-all-section" *ngIf="i == 5">
                  <a
                    class="view-all-content"
                    [routerLink]="['/help-center/' + category.code]"
                    (click)="showCategoryAccordion()"
                    >View more</a
                  >
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</section>
